/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Trans } from 'react-i18next';
import i18n from '@launchpad/i18n';
import ModalDialog from '../../../components/modal/ModalDialog';
import ModalService from '../../../logic/services/ModalService';
import NumberHelper from '../../../util/NumberHelper';
import DateHelper from '../../../util/DateHelper';
import {
  AppIcon,
  AppButton,
  LPOverridable,
  OverrideService
} from '../../../index';

export default class TransactionInfoModal extends React.PureComponent {
  render() {
    const { transaction } = this.props;
    const isFX =
      transaction.originalAmountCurrency &&
      transaction.originalAmountCurrency !== transaction.amountCurrency;
    const amount =
      transaction.amount === 0
        ? NumberHelper.currency(transaction.fee, transaction.amountCurrency)
        : NumberHelper.currency(transaction.amount, transaction.amountCurrency);

    const formatedType = transaction.typeReadable
      ? transaction.typeReadable.replace('_', ' ')
      : transaction.typeReadable;
    const dataToShow = [
      {
        label: i18n.t('Type:'),
        className: 'transaction-type',
        value: formatedType
      },
      {
        label: i18n.t('Status:'),
        className: 'transaction-status',
        value: transaction.statusReadable
      },
      {
        label: i18n.t('Transaction Date:'),
        className: 'transaction-date',
        value: DateHelper.fullDate(transaction.postDate)
      },
      {
        label: i18n.t('Settlement Date:'),
        className: 'transaction-settlement-date',
        value: DateHelper.fullDate(transaction.transactionDate)
      }
    ];

    let fee = parseFloat(transaction.fee);
    if (parseFloat(transaction.fee)) {
      if (isFX && transaction.status === 'settled') {
        fee -= parseFloat(transaction.fxPadding);
      }
    }

    if (transaction.amount === 0 && transaction.fee > 0) {
      fee = null;
    }

    if (isFX) {
      const rate = Math.abs(transaction.originalAmount / transaction.amount);
      dataToShow.push({
        label: i18n.t('Spent:'),
        className: 'transaction-spent',
        value: NumberHelper.currency(
          transaction.originalAmount,
          transaction.originalAmountCurrency
        )
      });
      dataToShow.push({
        label: i18n.t('FX rate'),
        className: 'transaction-fx-rate',
        value: `${NumberHelper.currency(
          1,
          transaction.amountCurrency
        )} = ${NumberHelper.currency(rate, transaction.originalAmountCurrency)}`
      });
      if (fee) {
        dataToShow.push({
          label: i18n.t('Fee:'),
          className: 'transaction-fee',
          value: NumberHelper.currency(
            parseFloat(transaction.fee) - parseFloat(transaction.fxPadding),
            transaction.amountCurrency
          )
        });
      }
    } else if (fee) {
      dataToShow.push({
        label: i18n.t('Fee:'),
        className: 'transaction-fee',
        value: NumberHelper.currency(
          parseFloat(transaction.fee),
          transaction.amountCurrency
        )
      });
    }

    dataToShow.push({
      label: i18n.t('Running Balance:'),
      className: 'transaction-running-balance',
      value: NumberHelper.currency(
        transaction.runningBalance,
        transaction.amountCurrency
      )
    });

    const fullDate = DateHelper.fullDate(transaction.transactionDate);

    return (
      <ModalDialog id="TRANSACTION_INFO" show>
        <div
          className={`transaction-modal ${
            transaction.status ? `transaction-status-${transaction.status}` : ''
          }`}
        >
          <div className="close-btn">
            <AppIcon
              name="fa.times"
              style={{
                fontSize: 24,
                cursor: 'pointer'
              }}
              onClick={() => ModalService.hideModal()}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              minWidth: '80%'
            }}
          >
            {(transaction?.merchant?.image &&
              transaction?.merchant?.image !== 'not_found') ||
            (transaction?.merchant?.externalData?.visual_enrichments
              ?.merchant_logo_link &&
              transaction?.merchant?.externalData?.visual_enrichments
                ?.merchant_logo_link !== 'not_found') ? (
              <img
                src={
                  transaction?.merchant?.image ||
                  transaction?.merchant?.externalData?.visual_enrichments
                    ?.merchant_logo_link
                }
                alt="merchant-logo"
                style={{
                  width: 80,
                  height: 80,
                  marginBottom: 10,
                  borderRadius: '50%'
                }}
              />
            ) : (
              <span
                className="icon-holder"
                style={{ marginTop: 10, marginBottom: 20 }}
              >
                <i
                  className="fa fa-info"
                  aria-hidden
                  style={{ fontSize: 31 }}
                />
              </span>
            )}
            <h4>{i18n.t(transaction.note)}</h4>
            <div style={{ marginTop: 10 }}>{fullDate}</div>
            <p className="tx-amount">{amount}</p>
            <div className="transaction-details">
              {dataToShow.map((x, index) => {
                return (
                  <div
                    className={`row ${x.className ? x.className : ''}`}
                    key={`transaction${index}`}
                  >
                    <div className="col-xs-6 detail-label">
                      {i18n.t(x.label)}
                    </div>
                    <div className="col-xs-6 detail-value">
                      {i18n.t(x.value)}
                    </div>
                  </div>
                );
              })}
            </div>
            {transaction.fxFee && (
              <a
                // eslint-disable-next-line no-script-url
                href="javascript:void(0)"
                onClick={() =>
                  ModalService.showModal('FX_INFO', { transaction })
                }
              >
                <Trans>Transaction Fees</Trans>
              </a>
            )}
            {!OverrideService.getOverrides()['hide-merchant-info'] &&
              transaction.merchantName && (
                <div style={{ marginTop: 10 }}>
                  <a
                    // eslint-disable-next-line no-script-url
                    href="javascript:void(0)"
                    onClick={() =>
                      ModalService.showModal('MERCHANT_INFO', {
                        id: transaction.id
                      })
                    }
                  >
                    <Trans>Merchant Info</Trans>
                  </a>
                </div>
              )}
          </div>
          <LPOverridable name="transaction.details.modal.bottom">
            <div
              style={{
                display: 'flex',
                flex: 0.5,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <AppButton
                customstyle={{ maxWidth: 450, maxHeight: 50, marginTop: 10 }}
                onClick={() => ModalService.hideModal()}
              >
                <Trans>YOU DON’T RECOGNIZE THIS TRANSACTION?</Trans>
              </AppButton>
            </div>
          </LPOverridable>
        </div>
      </ModalDialog>
    );
  }
}
